import React from "react"

const CustomItemPreview = ({ contribution, handleDelete, progress }) => {
  const { name, target, images, description } = contribution
  const price = parseInt(target - progress)
  return (
    <div className="mobiles:text-center">
      <img
        style={{ objectFit: "cover" }}
        src={images?.length ? images[0] : ""}
        className="w-full h-60 mobiles:h-28 rounded-tr-md rounded-tl-md block"
        alt=""
      />
      <div className="px-3 border border-gray-200 mobiles:border-transparent mobiles:pb-3 py-2">
        <p className="font-semibold">{`${name}`}</p>
        <p className="text-gray-600 mobiles:text-xs text-sm mt-2 truncate">
          {`${description}`}
        </p>
        <p className="mt-2 mobiles:hidden">₦{`${price}`}</p>
        <div className="items-center hidden mobiles:flex justify-center mt-4">
          <p className="ml-3 text-xs">₦{`${price}`}</p>
        </div>
      </div>
      <div className="grid mobiles:justify-center grid-cols-1">
        <button
          style={{ backgroundColor: "#6F64F8" }}
          onClick={() => handleDelete()}
          className="px-3 py-3 w-full  text-center flex items-center justify-center mobiles:hidden rounded-br-md"
        >
          <img
            src={require("../../assets/shopping-bag.svg").default}
            className="w-5 mr-3"
            alt=""
          />
          <span style={{ fontSize: "18px" }} className="text-white">
            Remove
          </span>
        </button>

        <button
          style={{ backgroundColor: "#6F64F8" }}
          className="px-3 mobiles:py-2 py-3 w-full mobiles:w-auto hidden text-center mobiles:flex items-center justify-center mobiles:rounded rounded-br-md"
          onClick={() => handleDelete()}
        >
          <img
            src={require("../../assets/shopping-bag.svg").default}
            className="h-4 mr-3"
            alt=""
          />
          <span style={{ fontSize: "14px" }} className="text-white">
            Remove
          </span>
        </button>
      </div>
    </div>
  )
}

export default CustomItemPreview
